export class CardStorageManager {

    _key;
    _cards = {};

    constructor(key) {
        this._key = key;
    }

    init() {
        const cards = sessionStorage.getItem(this._key);
        if ( cards ) this._cards = JSON.parse(cards);
    }

    readCard(card) {
        return this._cards[card];
    }

    saveCard(card, state) {
        const prevState = this.readCard(card);
        this._cards[card] = { ...prevState, ...state };
        this._save();
    }

    _save() {
        sessionStorage.setItem(this._key, JSON.stringify(this._cards));
    }

    clear() {
        sessionStorage.clear();
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/utils/CardStorageManager.js